import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60ad2d9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "my-4"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-sm-9 d-flex justify-content-between align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "col-12 col-sm-3 mt-3 mt-sm-0" }
const _hoisted_9 = {
  selected: "",
  value: "asc"
}
const _hoisted_10 = { value: "desc" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_13 = { class: "table-light" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.checkRoute())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFilterChange && _ctx.handleFilterChange(...args))),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.code) = $event)),
                type: "search",
                class: "form-control flex-fill me-3",
                id: "codeFilter",
                placeholder: _ctx.$t.filterByCode
              }, null, 40, _hoisted_5), [
                [_vModelText, _ctx.filters.code]
              ]),
              _withDirectives(_createElementVNode("input", {
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFilterChange && _ctx.handleFilterChange(...args))),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.division) = $event)),
                type: "search",
                class: "form-control flex-fill me-3",
                id: "divisionFilter",
                placeholder: _ctx.$t.filterByDivision
              }, null, 40, _hoisted_6), [
                [_vModelText, _ctx.filters.division]
              ]),
              _withDirectives(_createElementVNode("input", {
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleFilterChange && _ctx.handleFilterChange(...args))),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.group) = $event)),
                type: "search",
                class: "form-control flex-fill me-3",
                id: "groupFilter",
                placeholder: _ctx.$t.filterByGroup
              }, null, 40, _hoisted_7), [
                [_vModelText, _ctx.filters.group]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                id: "sortOrder",
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleFilterChange && _ctx.handleFilterChange(...args))),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.orderBy) = $event))
              }, [
                _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t.ascending), 1),
                _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t.descending), 1)
              ], 544), [
                [_vModelSelect, _ctx.orderBy]
              ])
            ]),
            _hoisted_11
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Loading, {
      active: _ctx.renderComponent,
      "onUpdate:active": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.renderComponent) = $event)),
      "can-cancel": false,
      "is-full-page": false
    }, null, 8, ["active"]),
    (!_ctx.renderComponent)
      ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
          _createElementVNode("thead", _hoisted_13, [
            _createElementVNode("tr", null, [
              _hoisted_14,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, key) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: `${ key }-${ header }-${ Math.random().toString(36).slice(2, 7) }`,
                  scope: "col"
                }, _toDisplayString(header), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entities, (entity, key, index) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent(_ctx.regionEnum.Table, _ctx.objectTypeEnum.Row)), {
                rerender: _ctx.changeRender,
                key: `${ key }-${ index }-${ Math.random().toString(36).slice(2, 7) }`,
                entity: entity,
                index: key
              }, null, 8, ["rerender", "entity", "index"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}